import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
{
    id: "po-06-h0v6-01",
    name: "PO 01 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 93, y: 186, width: 254, height: 480, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 355, y: 186, width: 121, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 355, y: 430, width: 121, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 607, y: 131, width: 321, height: 593, rotation: 0, imageRotation: 0 },
            { id: "5", x: 936, y: 131, width: 163, height: 293, rotation: 0, imageRotation: 0 },
            { id: "6", x: 936, y: 432, width: 163, height: 292, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h0v6-02",
    name: "PO 02 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 172, width: 142, height: 252, rotation: 0, imageRotation: 0 },
        { id: "2", x: 58, y: 432, width: 142, height: 251, rotation: 0, imageRotation: 0 },
        { id: "3", x: 208, y: 172, width: 302, height: 511, rotation: 0, imageRotation: 0 },
        { id: "4", x: 627, y: 172, width: 302, height: 511, rotation: 0, imageRotation: 0 },     
        { id: "5", x: 937, y: 172, width: 142, height: 252, rotation: 0, imageRotation: 0 },
        { id: "6", x: 937, y: 432, width: 142, height: 251, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-03",
    name: "PO 03 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 44, y: 131, width: 322, height: 593, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 374, y: 131, width: 152, height: 293, rotation: 0, imageRotation: 0 },
        { id: "3", x: 374, y: 432, width: 152, height: 292, rotation: 0, imageRotation: 0 },
        { id: "4", x: 656, y: 189, width: 253, height: 475, rotation: 0, imageRotation: 0 },
        { id: "5", x: 917, y: 189, width: 133, height: 234, rotation: 0, imageRotation: 0 },
        { id: "6", x: 917, y: 431, width: 133, height: 233, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-04",
    name: "PO 04 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 48, y: 224, width: 233, height: 406, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 224, width: 232, height: 406, rotation: 0, imageRotation: 0 },
        { id: "3", x: 615, y: 131, width: 350, height: 593, rotation: 0, imageRotation: 0 },
        { id: "4", x: 973, y: 131, width: 117, height: 193, rotation: 0, imageRotation: 0 },
        { id: "5", x: 973, y: 332, width: 117, height: 192, rotation: 0, imageRotation: 0 },
        { id: "6", x: 973, y: 532, width: 117, height: 192, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-05",
    name: "PO 05 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
    size: [1136, 854],
    style: {},
    slots: [  
        { id: "1", x: 44, y: 224, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "2", x: 44, y: 431, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "3", x: 169, y: 224, width: 231, height: 406, rotation: 0, imageRotation: 0 },
        { id: "4", x: 408, y: 224, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "5", x: 408, y: 431, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "6", x: 568, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-06-h0v6-06",
    name: "PO 06 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 47, y: 131, width: 117, height: 193, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 332, width: 117, height: 192, rotation: 0, imageRotation: 0 },
        { id: "3", x: 47, y: 532, width: 117, height: 192, rotation: 0, imageRotation: 0 },
        { id: "4", x: 172, y: 131, width: 350, height: 593, rotation: 0, imageRotation: 0 },
        { id: "5", x: 615, y: 224, width: 234, height: 406, rotation: 0, imageRotation: 0 },
        { id: "6", x: 857, y: 224, width: 234, height: 406, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-07",
    name: "PO 07 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 610, y: 224, width: 234, height: 406, rotation: 0, imageRotation: 0 },
        { id: "3", x: 852, y: 224, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "4", x: 852, y: 431, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "5", x: 977, y: 224, width: 117, height: 199, rotation: 0, imageRotation: 0 },
        { id: "6", x: 977, y: 431, width: 117, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-08",
    name: "PO 08 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 136, width: 390, height: 582, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 398, y: 136, width: 166, height: 287, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 136, width: 166, height: 287, rotation: 0, imageRotation: 0 },
        { id: "4", x: 398, y: 431, width: 166, height: 287, rotation: 0, imageRotation: 0 },
        { id: "5", x: 572, y: 431, width: 166, height: 287, rotation: 0, imageRotation: 0 },
        { id: "6", x: 746, y: 136, width: 390, height: 582, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-09",
    name: "PO 09 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 269, width: 183, height: 317, rotation: 0, imageRotation: 0 },
        { id: "2", x: 191, y: 269, width: 183, height: 317, rotation: 0, imageRotation: 0 },
        { id: "3", x: 382, y: 269, width: 183, height: 317, rotation: 0, imageRotation: 0 },
        { id: "4", x: 573, y: 269, width: 183, height: 317, rotation: 0, imageRotation: 0 },
        { id: "5", x: 764, y: 269, width: 182, height: 317, rotation: 0, imageRotation: 0 },
        { id: "6", x: 954, y: 269, width: 182, height: 317, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-10",
    name: "PO 10 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 40, y: 280, width: 170, height: 295, rotation: 0, imageRotation: 0 },
        { id: "2", x: 218, y: 280, width: 170, height: 295, rotation: 0, imageRotation: 0 },
        { id: "3", x: 396, y: 280, width: 169, height: 295, rotation: 0, imageRotation: 0 },
        { id: "4", x: 573, y: 280, width: 169, height: 295, rotation: 0, imageRotation: 0 },
        { id: "5", x: 750, y: 280, width: 169, height: 295, rotation: 0, imageRotation: 0 },
        { id: "6", x: 927, y: 280, width: 169, height: 295, rotation: 0, imageRotation: 0 }
    ],
}
];